<vcl-alert id="alert-one-time-password" class="mt-3" *ngIf="alertModel && alertModel.message && alertModel.type" [type]="alertModel.type" [icon]="alertModel.icon">
    {{ alertModel.message }}
</vcl-alert>

<div id="otp-container" class="mt-4">
    
    <div class="space">
        <span class="title">{{ copyService.copies.one_time_password.title }}</span>
        <div class="note">
            <span class="info">
                <span [innerHTML]="copyService.copies.one_time_password.subtitle"></span>
                <strong><span class="cellphone"> {{ validationHelperService.maskPhone(phone) }} </span></strong>
                {{ copyService.copies.one_time_password.subtitle1 }}                
            </span>
        </div>
        <div class="px-0 col-4 col-pr-6 col-sm-4 col-md-4 col-xl-4">
            <voxel-input ngDefaultControl id="input-confirmation-code" placeholder="{{copyService.copies.one_time_password.input_placeholder}}" maxlength="6" type="number" label="{{copyService.copies.one_time_password.input_label}}" [value]="this.numberCode" (inputChange)="reactiveInputChangeCode($event)">
            </voxel-input>
        </div>
        <div class="help px-0 col-4 col-pr-12 col-sm-4 col-md-4 col-xl-4">
            <span class="info">
                {{copyService.copies.one_time_password.title_info}}
            </span>
            <div class="btn-secondary-container">
                <vcl-button id="button-contextual-resend" class="btn-resend" label="{{copyService.copies.one_time_password.button_resend}}" buttonType="contextual" (click)="resendConfirmationCode()" [disableRipple]="true"></vcl-button>
                <vcl-button id="button-contextual-problems" class="btn-problems" label="{{copyService.copies.one_time_password.button_problem}}" buttonType="contextual" (click)="gotoProblems()" [disableRipple]="true"></vcl-button>
            </div>
        </div>
    </div>
</div>
<app-controls [hasPrevious]="true" [nextLabel]="copyService.copies.one_time_password.button" [nextDisabled]="!formGroup.valid" (only_previous)="sendBackButtonEvent()" (next)="validateOtpCode()"></app-controls>

